import { defineTokens } from '@pandacss/dev'

export const spacing = defineTokens.spacing({
  4.5: { value: '1.125rem' },
  14: { value: '3.5rem' },
})
